import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { featureBlocks } from "../data/content";
export function FeatureBlocks() {
  return <section className="bg-white px-4 pb-14" aria-label="Benefits" data-id="element-61" data-mp="g3t142k7celt">
      <div className="mx-auto max-w-5xl space-y-8" data-id="element-62" data-mp="g42snukwattm">
        {featureBlocks.map(b => <article key={b.titleDark} className="grid items-center gap-8 rounded-lg border border-brand/40 bg-white p-6 md:grid-cols-2 md:p-10" data-id="element-63" data-mp="b619l9ngyui5">
            <div className={b.reverse ? "md:order-2" : ""} data-id="element-64" data-mp="18ub0asht1vty">
              <h3 className="font-heading text-2xl font-bold uppercase leading-tight" data-id="element-65" data-mp="13uq4us1ug5lz">
                {b.titleDark} <span className="text-brand" data-id="element-66" data-mp="z13yfhm9wxym">{b.titleAccent}</span>
              </h3>
              {b.paragraphs.map(p => <p key={p} className="mt-4 text-sm leading-relaxed text-ink-muted" data-id="element-67" data-mp="u3bvlsk3brfn">{p}</p>)}
              {b.bullets && <ul className="mt-4 space-y-2" data-id="element-68" data-mp="1rkantaxzz2v9">
                  {b.bullets.map(x => <li key={x} className="flex items-start gap-2 text-sm" data-id="element-69" data-mp="1mr80vlnq6ro1">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-70" data-mp="gf3aeqgp5dl" />
                      {x}
                    </li>)}
                </ul>}
              {b.cta && <div className="mt-6 flex md:justify-start" data-id="element-71" data-mp="3mwj9htad9pe8">
                  <CtaButton label="Download now" data-id="element-72" data-mp="3mw02h7m98lez" />
                </div>}
            </div>
            <img src={b.image} alt={b.imageAlt} className={`aspect-[4/3] w-full rounded-lg object-cover ${b.reverse ? "md:order-1" : ""}`} data-id="element-73" data-mp="3rubcbicjuvx7" />
          </article>)}
      </div>
    </section>;
}